import reduceReducers from 'reduce-reducers';

//Siblings reducers
import patientReducer from './patient-reducer';

export default reduceReducers(patientReducer);
